<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.dhp_extensions.form.labels.extension')"
            :is-required="true"
            :error="errors.extension"
            :hint="__('settings.dhp_extensions.form.labels.extension_hint')"
        >
            <DInput
                id="sub_type"
                v-model="form.extension"
                add-input-classes="bg-light"
                maxlength="255"
                :disabled="!!dhpExtension.extension"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.dhp_extensions.form.labels.group')"
            :is-required="true"
            :error="errors.group"
            :hint="__('settings.dhp_extensions.form.labels.group_hint')"
        >
            <DInput
                id="group"
                v-model="form.group"
                add-input-classes="bg-light"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.dhp_extensions.form.labels.price')"
            :is-required="true"
            :error="errors.price"
            :hint="__('settings.dhp_extensions.form.labels.price_hint')"
        >
            <DInputGroup>
                <DInputGroupText
                    :value="DHP_CURRENCY"
                />
                <DInput
                    id="price"
                    v-model="form.price"
                    add-input-classes="bg-light"
                />
            </DInputGroup>
        </DFormRow>
        <DFormRow
            :label="__('settings.dhp_extensions.form.labels.price_period')"
            :is-required="true"
            :error="errors.price_period"
            :hint="__('settings.dhp_extensions.form.labels.price_period_hint')"
        >
            <DInput
                id="sub_type"
                v-model="form.price_period"
                add-input-classes="bg-light"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.dhp_extensions.form.labels.price_period_unit')"
            :is-required="true"
            :error="errors.price_period_unit"
            :hint="__('settings.dhp_extensions.form.labels.price_period_unit_hint')"
        >
            <DSelect
                id="type"
                v-model="form.price_period_unit"
                :options="dateUnits"
                :value="dhpExtension.price_period_unit"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.dhp_extensions.form.labels.contract_term')"
            :is-required="true"
            :error="errors.contract_term"
            :hint="__('settings.dhp_extensions.form.labels.contract_term_hint')"
        >
            <DInput
                id="sub_type"
                v-model="form.contract_term"
                add-input-classes="bg-light"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.dhp_extensions.form.labels.contract_term_unit')"
            :is-required="true"
            :error="errors.contract_term_unit"
            :hint="__('settings.dhp_extensions.form.labels.contract_term_unit_hint')"
        >
            <DSelect
                id="type"
                v-model="form.contract_term_unit"
                :options="dateUnits"
                :value="dhpExtension.contract_term_unit"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.dhp_extensions.form.labels.accounting_information')"
            :error="errors.accounting_information"
            :hint="__('settings.dhp_extensions.form.labels.accounting_information_hint')"
        >
            <DInput
                id="accounting_information"
                v-model="form.accounting_information"
                :placeholder="__('settings.dhp_extensions.form.labels.accounting_information')"
                type="string"
            />
        </DFormRow>
        <DFormControls
            :cancel-route="getIndex()"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'

// DHP extensions are sold in a single market region whose currency is EUR, so the price is not
// derived from the tenant currency setting or from a market region.
const DHP_CURRENCY = 'EUR'

const props = defineProps({
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    },
    dhpExtension: {
        type: Object,
        default: () => {
            return {}
        }
    },
    dateUnits: {
        type: Array,
        default: () => {
            return []
        }
    }
})

const emit = defineEmits(['form-submitted'])

const form = useForm({
    extension: props.dhpExtension?.extension,
    price: props.dhpExtension?.price,
    price_period: props.dhpExtension?.price_period,
    price_period_unit: props.dhpExtension?.price_period_unit,
    contract_term: props.dhpExtension?.contract_term,
    contract_term_unit: props.dhpExtension?.contract_term_unit,
    group: props.dhpExtension?.group,
    accounting_information: props.dhpExtension?.accounting_information
})

function submitForm () {
    emit('form-submitted', form)
}

function getIndex () {
    return route('settings.dhp-extensions.index')
}
</script>
